import React, { useEffect, useRef, useState } from "react";
import Button from '../UI/Button';

const INSTRUCTIONS = [
    "Смотрите прямо в камеру",
    "Поверните голову влево",
    "Поверните голову вправо",
    "Наклоните голову вниз",
    "Наклоните голову вверх",
];

const MultiPhotoCapture = ({ onCaptureComplete,  resetCapture}) => {
    const videoRef = useRef(null);
    const [stream, setStream] = useState(null);
    const [capturedPhotos, setCapturedPhotos] = useState([]);
    const [step, setStep] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (resetCapture) {
            setStep(0);
            setCapturedPhotos([]);
        }
    }, [resetCapture]);
    

    useEffect(() => {
        const start = async () => {
            try {
                const mediaStream = await navigator.mediaDevices.getUserMedia({
                    video: true,
                });
                setStream(mediaStream);
                if (videoRef.current) {
                    videoRef.current.srcObject = mediaStream;
                }
            } catch (err) {
                console.error("Ошибка запуска камеры:", err);
            }
        };

        start();

        return () => {
            if (stream) {
                stream.getTracks().forEach((track) => track.stop());
            }
        };
    }, []);

    const captureCurrentFrame = () => {
        if (!videoRef.current) return;
        const canvas = document.createElement("canvas");
        canvas.width = videoRef.current.videoWidth;
        canvas.height = videoRef.current.videoHeight;
        canvas.getContext("2d").drawImage(videoRef.current, 0, 0);

        canvas.toBlob((blob) => {
            const file = new File([blob], `photo_${step}.jpg`, {
                type: "image/jpeg",
            });
            const newPhotos = [...capturedPhotos, file];
            setCapturedPhotos(newPhotos);

            if (step < INSTRUCTIONS.length - 1) {
                setStep(step + 1);
            } else {
                setStep(step + 1); 
                onCaptureComplete(newPhotos);
            }
        }, "image/jpeg");
    };

    return (
        <div className="space-y-4 w-full">
            <div className="text-center font-semibold text-lg text-white">
                {INSTRUCTIONS[step]}
            </div>

            <div className="flex justify-center">
                <video
                    ref={videoRef}
                    autoPlay
                    className="rounded border border-gray-600 w-full max-w-md"
                />
            </div>

            <div className="flex justify-center gap-4">
                {step < INSTRUCTIONS.length && (
                    <Button
                        type="button"
                        onClick={captureCurrentFrame}
                        disabled={loading}
                        variant="secondary"
                    >
                        Сфотографировать ({step + 1}/{INSTRUCTIONS.length})
                    </Button>
                )}
                {capturedPhotos.length > 0 && step === INSTRUCTIONS.length && (
                    <span className="text-green-400">Все фото сделаны ✅</span>
                )}
            </div>
        </div>
    );
};

export default MultiPhotoCapture;
